import store from "@/state/store";
import { route_acl_map } from "../components/route-acl-map";

const pre_reg_url = process.env.VUE_APP_PRE_REGISTRATION_URL;
// limit access for stand alone kiosk
const protectedRoutes = (routeTo, routeFrom, next) => {
  const currentPackage = store.getters["authfack/currentEntity"].package
  if (currentPackage == "Cloud") {

    const dashboardUrl = window.location.origin
    const permissions = store.getters["authfack/getUserPermissions"]
    const currentRouteAcl = route_acl_map[routeTo?.matched[0]?.path]
    const isAllowed = permissions[currentRouteAcl]?.pivot.allowed
    if (isAllowed === 1) {
      next();
    } else if (isAllowed === 0) {
      window.location.href = dashboardUrl
    } else { //remove when all routes are handled in acl
      next()
    }
  } else if (currentPackage == "Standalone") {
    next({ name: "sitesList" });
  } else {
    next({ name: "errorRoute" });
  }
};

export default [
  {
    path: "/error",
    name: "SorryPage",
    meta: {
      authRequired: true,
      noLayout: true
    },
    component: () => import("../components/sorryPage/SorryPage"),
  },
  {
    path: "/otp-error",
    name: "otpErrorPage",
    meta: {
      authRequired: true,
      noLayout: true
    },
    component: () => import("../components/sorryPage/otpErrorPage"),
  },
  {
    path: "/passport",
    name: "passport",
    beforeEnter: (routeTo) => {
      // console.log('query', routeTo.query)
      if (routeTo.query.journey_flow_id) {
        window.location.href =
          process.env.VUE_APP_BASE_URL_PASSPORT_REDIRECT +
          "/login?" +
          "journey_flow_id=" +
          (routeTo.query.journey_flow_id ? routeTo.query.journey_flow_id : "") +
          "&redirect_url=" +
          (routeTo.query.redirect_url ? window.location.href : "") +
          "&app_domain=" +
          process.env.VUE_APP_DOMAIN +
          '&visit_date=' +
          (routeTo.query.visit_date ? routeTo.query.visit_date : "") +
          '&visit_time=' +
          (routeTo.query.visit_time ? routeTo.query.visit_time : "") +
          '&entity_id=' +
          (routeTo.query.entity_id ? routeTo.query.entity_id : "") +
          '&user_type_id=' +
          (routeTo.query.user_type_id ? routeTo.query.user_type_id : "") +
          '&area_id=' +
          (routeTo.query.area_id ? routeTo.query.area_id : "") +
          '&registration_method=' +
          (routeTo.query.registration_method ? routeTo.query.registration_method : "") +
          '&emailExists=' +
          (routeTo.query.emailExists ? routeTo.query.emailExists : "") +
          (routeTo.query.email ? "&email=" + encodeURIComponent(routeTo.query.email) : "") +
          (routeTo.query.phone ? "&phone=" + encodeURIComponent(routeTo.query.phone) : "");
      } else if (routeTo.query.add_visitor) {
        window.location.href =
          process.env.VUE_APP_BASE_URL_PASSPORT_REDIRECT +
          "/login?" +
          "add_visitor=" + routeTo.query.add_visitor +
          "&serverUrl=" + routeTo.query.serverUrl +
          '&visit_url=' + routeTo.query.visit_url +
          (routeTo.query.email ? "&email=" + encodeURIComponent(routeTo.query.email) : "") +
          (routeTo.query.phone ? "&phone=" + encodeURIComponent(routeTo.query.phone) : "");
      }
    },
    meta: {
      // authRequired: true,
      // beforeResolve() {
      //   window.location.href = process.env.VUE_APP_BASE_URL_PASSPORT_REDIRECT;  
      // },
    },
  },

  {
    path:"/vp/playground",
    name:"playground",
    component:()=>import("./views/playground/index.vue"),
  },
  {
    path: "/company",
    name: "Company",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        next();
      },
    },
    component: () => import("./views/dashboards/NewCompanyDetails"),
    beforeEnter: (to, from, next) => {
      const isLtTechteam = store.getters["authfack/userDetails"].email == 'lt_techteam@visipoint.com'
      // store.dispatch("sites/clearSitesWithAreasAndKiosksTreeList");
      if (store.getters["authfack/currentEntity"].package == 'Cloud' || (store.getters["authfack/currentEntity"].package == 'Standalone' && !isLtTechteam)) protectedRoutes(to, from, next)
      else if (store.getters["authfack/currentEntity"].package == 'Standalone' && isLtTechteam) next()
      else next({ name: "sitesList" })
    }
  },
  {
    path: "/",
    name: "dashboard",
    meta: { authRequired: true },
    component: () => import("./views/dashboards/Dashboard"),
    beforeEnter: (to, from, next) => {
      if (store.getters["authfack/currentEntity"].package == "Cloud") {
        setTimeout(() => {
          next();
        }, 500);
      } else {
        // next({ name: "errorRoute" });
      }
    },
  },
  {
    path: "/filtered",
    name: "dashboard",
    meta: { authRequired: true },
    component: () => import("../components/sharedComponents/GlobalFormLayout.vue"),
    beforeEnter: (to, from, next) => {
      if (store.getters["authfack/currentEntity"].package == "Cloud") {
        store.dispatch("dailyLogbook/fetchUserTypes");
        store.dispatch("dailyLogbook/fetchInputTypes");
        store.dispatch("dailyLogbook/fetchAreas");
        store.dispatch("dailyLogbook/fetchScanDatatypesForDashboard");

        setTimeout(() => {
          next();
        }, 500);
      } else {
        // next({ name: "errorRoute" });
      }
    },
  },
  // login
  {
    path: "/login",
    name: "login",
    component: () => import("./views/account/login"),
    beforeEnter: (routeTo, routeFrom, next) => {
      localStorage.setItem("user", null);
      console.log('window.location.origin', window.location.origin);
      if (window.location.origin == process.env.VUE_APP_DOMAIN) {
        window.location.href = process.env.VUE_APP_BASE_URL_PASSPORT_REDIRECT;
      } else {
        next();
      }
    },
    meta: {
      noLayout: true
    },
  },
  // forget password
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("./views/account/forgot-password"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters["auth/loggedIn"]) {
          next({ name: "default" });
        } else {
          next();
        }
      },
    },
  },
  // logout
  {
    path: "/logout",
    name: "logout",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch("authfack/logout");
        setTimeout(() => {
          localStorage.removeItem("currentlyEntity");
        }, 1000);
        const authRequiredOnPreviousRoute = routeFrom.matched.some((route) =>
          route.push("/login")
        );
        // Navigate back to previous page, or home as a fallback
        next(
          authRequiredOnPreviousRoute
            ? { name: "/daily-logbook" }
            : { ...routeFrom }
        );
      },
    },
  },
  {
    path: "/sso/:id?/:atex?/:entityId?/:ip?",
    name: "SSO",
    meta: {
      beforeResolve(routeTo, next) {
        store.dispatch("authfack/onPassportAuth", routeTo.query);
        next({ name: "dashboard" });
      },
    },
  },

  // error
  // users
  {
    path: "/404",
    name: "errorRoute",
    meta: {
      authRequired: true,
    },
    component: () => import("../components/error404/errorRoute"),
  },
  {
    path: "/kiosk-register",
    name: "kioskRegisteration",
    meta: {
      authRequired: false,
    },
    component: () => import("./views/kiosks/RegisterKiosk"),
  },

  // Redirect any unmatched routes to the 404 page. This may
  {
    path: "*",
    redirect: "404",
  },

  // users
  // {
  //   path: "/oldusers",
  //   name: "users",
  //   meta: { authRequired: true },
  //   component: () => import("./views/users/index"),
  //   beforeEnter: protectedRoutes,
  // },
  {
    path: "/users",
    name: "users",
    meta: { authRequired: true },
    component: () => import("./views/users/UsersDxGrid"),
    beforeEnter: protectedRoutes,
  },
  {
    path: "/announcements",
    name: "announcements",
    meta: { authRequired: true },
    component: () => import("./views/announcements/announcementsGrid"),
    beforeEnter: protectedRoutes,
  },
  {
    path: "/add-announcement",
    name: "addAnnouncementForm",
    meta: { authRequired: true },
    component: () => import("./views/announcements/addAnnouncement"),
    beforeEnter: protectedRoutes,
  },
  {
    path: "/announcement-details",
    name: "announcementsData",
    meta: { authRequired: true },
    component: () => import("./views/announcements/announcementsData"),
    beforeEnter: protectedRoutes,
  },
  {
    path: "/duplication-control-board",
    name: "UsersSettings",
    meta: { authRequired: true },
    component: () => import("./views/users/UsersConflicts"),
    beforeEnter: protectedRoutes,
  },
  {
    path: "/users/import",
    name: "Import users",
    meta: { authRequired: true },
    component: () => import("./views/users/import"),
    beforeEnter: protectedRoutes,
  },
  {
    path: "/users/import/grid",
    name: "importUsersGrid",
    meta: { authRequired: true },
    component: () => import("./views/users/ImportUsersGrid"),
    beforeEnter: protectedRoutes,
  },
  {
    path: "/users/import/queue",
    name: "importQueue",
    meta: { authRequired: true },
    component: () => import("./views/users/UsersQueue"),
    beforeEnter: protectedRoutes,
  },
  {
    path: "/users/import/details/:id",
    name: "ImportDetails",
    meta: { authRequired: true },
    component: () => import("./views/users/ImportDetails"),
    beforeEnter: protectedRoutes,
  },

  // report
  {
    path: "/reporting/time",
    name: "reporting/time",
    meta: { authRequired: true },
    component: () => import("./views/report/time"),
    beforeEnter: protectedRoutes,
  },
  {
    path: "/reporting/history",
    name: "reporting/history",
    meta: { authRequired: true },
    component: () => import("./views/report/history"),
    beforeEnter: protectedRoutes,
  },
  {
    path: "/reporting/visit_summary",
    name: "visitsSummary",
    meta: { authRequired: true },
    component: () => import("./views/visit/VisitSummary"),
    beforeEnter: (to, from, next) => {
      store.dispatch("visit/clearVisitSummaryGrid");
      setTimeout(() => {
        protectedRoutes(to, from, next)
      }, 500);
    }
  },
  {
    path: "/reporting/users-not-on-site",
    name: "reporting/users-not-on-site",
    meta: { authRequired: true },
    component: () => import("./views/report/UsersNotOnSite"),
    beforeEnter: protectedRoutes,
  },
  {
    path: "/reporting/printer",
    name: "reporting/printer",
    meta: { authRequired: true },
    component: () => import("./views/report/printer"),
    beforeEnter: protectedRoutes,
  },
  {
    path: "/add-expected-visitors",
    name: "addExpectedVisitors",
    meta: { authRequired: true },
    component: () => import("./views/visit/expectedVisitors"),
    beforeEnter: protectedRoutes,
  },
  {
    path: "/reporting/kiosk-logs",
    name: "reporting/kiosk-logs",
    meta: { authRequired: true },
    component: () => import("./views/report/kiosk-logs/kioskLogs"),
    beforeEnter: protectedRoutes,
  },
  {
    path: "/reporting/timesheet",
    name: "reporting/timesheet",
    meta: { authRequired: true },
    component: () => import("./views/report/timesheet/timesheet"),
    beforeEnter: protectedRoutes,
  },

  {
    path: "/reporting/track-trace",
    name: "track/trace",
    meta: { authRequired: true },
    component: () => import("./views/report/trackAndTrace"),
    beforeEnter: protectedRoutes,
  },

  // sites
  {
    path: "/sites",
    name: "sitesList",
    meta: { authRequired: true },
    component: () => import("./views/site/SitesTreeList"),
    beforeEnter: (to, from, next) => {
      store.dispatch("sites/clearSitesWithAreasAndKiosksTreeList");
      if (store.getters["authfack/currentEntity"].package == 'Cloud') protectedRoutes(to, from, next)
      else next()
    }
  },
  {
    path: "/multiple-signin",
    name: "multiplesignin",
    meta: { authRequired: true },
    component: () => import("./views/dailylogUsersMassaction/multipleSignin"),
    beforeEnter: protectedRoutes,
  },
  {
    path: "/invite-users-to-dashboard",
    name: "inviteuserstodashboard",
    meta: { authRequired: true },
    component: () => import("./views/usersListMassaction/inviteToDashboard"),
    beforeEnter: protectedRoutes,
  },
  {
    path: "/rfid-enrollment",
    name: "rfidEnrollmentMassAction",
    meta: { authRequired: true },
    component: () => import("./views/users/rfidEnrollmentMassAction/RfidMassAction"),
    beforeEnter: protectedRoutes,
  },
  // user types
  {
    path: "/olduser-types",
    name: "olduserTypes",
    meta: { authRequired: true },
    component: () => import("./views/userTypes/index"),
    beforeEnter: protectedRoutes,
  },
  {
    path: "/user-types",
    name: "userTypes",
    meta: { authRequired: true },
    component: () => import("./views/userTypes/userTypesDxGrid"),
    beforeEnter: protectedRoutes,
  },
  {
    path: "/add-user-type",
    name: "addUserType",
    meta: { authRequired: true, parentRoutePath:"/user-types" },
    component: () => import("./views/userTypes/create"),
    beforeEnter: protectedRoutes,
  },

  // journeys
  {
    path: "/add-journey",
    name: "addJourney",
    meta: { authRequired: true ,parentRoutePath : "/journeys"},
    component: () => import("./views/journeyBuilder/CreateJourney"),
    beforeEnter: protectedRoutes,
  },
  {
    path: "/update/journey/:id",
    name: "updateJourney",
    meta: { authRequired: true ,parentRoutePath : "/journeys"},
    component: () => import("./views/journeyBuilder/CreateJourney"),
    beforeEnter: protectedRoutes,
  },
  {
    path: "/add-flow",
    name: "addFlow",
    meta: { authRequired: true ,parentRoutePath : "/journeys"},
    component: () => import("./views/journeyBuilder/CreateJourney"),
    beforeEnter: protectedRoutes,
  },
  {
    path: "/add/journey/flow/:id",
    name: "addJourneyFlow",
    meta: { authRequired: true ,parentRoutePath : "/journeys"},
    component: () => import("./views/journeyBuilder/CreateJourney"),
    beforeEnter: protectedRoutes,
  },
  {
    path: "/update/journey/flow/:id",
    name: "updateFlow",
    meta: { authRequired: true ,parentRoutePath : "/journeys" },
    component: () => import("./views/journeyBuilder/CreateJourney"),
    beforeEnter: protectedRoutes,
  },
  {
    path: "/journeys",
    name: "newJourneys",
    meta: { authRequired: true },
    component: () => import("./views/journeyBuilder/journeysTreeList"),
    beforeEnter: protectedRoutes,
  },

  // compliance
  {
    path: "/compliances",
    name: "compliances",
    meta: { authRequired: true },
    component: () => import("./views/compliance/ComplianceGrid"),
    beforeEnter: protectedRoutes,
  },
  {
    path: "/compliance-new",
    name: "createCompliance",
    meta: { authRequired: true ,parentRoutePath : "/compliances"},
    component: () => import("./views/compliance/CreateCompliance"),
    beforeEnter: protectedRoutes,
  },
  {
    path: "/compliance/update/:id",
    name: "updateCompliance",
    meta: { authRequired: true ,parentRoutePath : "/compliances"},
    component: () => import("./views/compliance/CreateCompliance"),
    beforeEnter: protectedRoutes,
  },
  {
    path: `/online-compliance/:id?`,
    name: "onlineCompliance",
    meta: {
      auth: false,
      authRequired: false,
      noLayout: true
    },
    component: () => import("./views/compliance/OnlineCompliance"),
  },
  {
    path: "/c/:visitUrl/:code?",
    name: "onlineComplianceFromEmail",
    meta: {
      auth: false,
      authRequired: false,
      noLayout: true
    },
    beforeEnter(routeTo, routeFrom, next) {
      if (routeTo.params.code) {
        store.dispatch("preRegistration/getPreRegDetails", {visitUrl: routeTo.params.visitUrl, onlineComp: true}).then((res) => {
          if (res.data.data.user && res.data.data.user.passport_id) {
            window.location.href =
              `${process.env.VUE_APP_BASE_URL_PASSPORT_REDIRECT}/login-code/${routeTo.params.visitUrl}/${routeTo.params.code}`;
          } else {
            window.location.href = `/c/${routeTo.params.visitUrl}`;
          }
        });
      } else {
        next({
          name: "onlineCompliance", params: {
            id: routeTo.params.visitUrl
          },
        });
      }
    }
  },

  // privacyManager
  {
    path: "/privacy-manager",
    name: "privacyManager",
    meta: { authRequired: true },
    component: () => import("./views/PrivacyManager/Grid.vue"),
    beforeEnter: protectedRoutes,
  },

  // customFields
  {
    path: "/custom-fields",
    name: "customFieldsList",
    meta: { authRequired: true },
    component: () => import("./views/customFields/customFieldsDxGrid.vue"),
    beforeEnter: protectedRoutes,
  },
  {
    path: "/add-custom-field",
    name: "addCustomField",
    meta: { authRequired: true ,parentRoutePath: "/custom-fields" },
    component: () => import("./views/customFields/addNewSection.vue"),
    beforeEnter: protectedRoutes,
  },

  //integration
  {
    path: "/integration",
    name: "addIntegration",
    meta: { authRequired: true },
    component: () => import("./views/integration/AddIntegration"),
    // beforeEnter: (to, from, next) => {
    // setTimeout(() => {
    //   next();
    // }, 5000);
    // },
    beforeEnter: protectedRoutes,
  },
  {
    path: "/integration-settings",
    name: "inegrationSettings",
    meta: { authRequired: true ,parentRoutePath : "/integration" },
    component: () => import("./views/integration/ManageIntegrationSettings"),
    //   beforeEnter: (to, from, next) => {
    //     // store.dispatch("integration/fetchTempUsersWithErrors", store.getters["integration/getIntegId"]);
    //     store.dispatch("integration/getIntegration", store.getters["integration/getIntegId"]);
    //   // store.dispatch("integration/redirectToIntegrationSettings");
    //   store.dispatch("integration/fetchTempUsersWithDuplicates", store.getters["integration/getIntegId"]);
    //   store.dispatch("integration/fetchTempUsersWithErrors", store.getters["integration/getIntegId"]);
    //   setTimeout(() => {
    //     next();
    //   }, 1100);
    // },
  },
  {
    path: "/sync-integration",
    name: "syncInegration",
    meta: { authRequired: true ,parentRoutePath : "/integration" },
    component: () => import("./views/integration/SyncIntegration"),
  },
  {
    path: "/sync-status",
    name: "syncStatus",
    meta: { authRequired: true ,parentRoutePath : "/integration" },
    component: () => import("./views/integration/SyncStatus"),
  },
  {
    path: "/integration-error",
    name: "importedWithErrors",
    meta: { authRequired: true , parentRoutePath : "/integration" },
    component: () => import("./views/integration/importedWithErrors"),
    beforeEnter: (to, from, next) => {
      // store.dispatch("integration/fetchTempUsersWithErrors", store.getters["integration/getIntegId"]);
      setTimeout(() => {
        next();
      }, 1000);
    },
  },
  {
    path: "/integration-duplicate",
    name: "importedWithDuplicates",
    meta: { authRequired: true ,parentRoutePath : "/integration" },
    component: () => import("./views/integration/importedWithDuplicates"),
    beforeEnter: (to, from, next) => {
      // store.dispatch("integration/fetchTempUsersWithDuplicates", store.getters["integration/getIntegId"]);
      setTimeout(() => {
        next();
      }, 500);
    },
  },
  {
    path: "/integration-valid",
    name: "validUsers",
    meta: { authRequired: true ,parentRoutePath : "/integration" },
    component: () => import("./views/integration/validUsers"),
    beforeEnter: (to, from, next) => {
      if (store.getters["integration/getFromView"]) {
        store.dispatch("integration/fetchSyncedUsers", store.getters["integration/getIntegId"]);
      } else {
        store.dispatch("integration/fetchValidTempUsers", store.getters["integration/getIntegId"]);
      }
      setTimeout(() => {
        next();
      }, 1000);
    },
  },
  {
    path: "/write-back",
    name: "writeBack",
    meta: { authRequired: true ,parentRoutePath : "/integration" },
    component: () => import("./views/integration/writeBackGrid"),
  },
  {
    path: "/attendance-codes/:integId/:integName",
    name: "attendanceCodes",
    meta: { authRequired: true ,parentRoutePath : "/integration" },
    component: () => import("./views/integration/attendanceCodesGrid"),
  },
  {
    path: "/view-integration/:integId/:integName",
    name: "viewIntegration",
    meta: { authRequired: true ,parentRoutePath : "/integration" },
    component: () => import("./views/integration/viewIntegration"),
  },
  {
    path: "/googleAD/auth/:accessToken/:refreshToken/:encryptedEmail",
    name: "googleIntegrationAuth",
    meta: { authRequired: true ,parentRoutePath : "/integration" },
    component: () => import("./views/integration/googleAD-auth"),
  },

  // pre-registration form
  {
    path: `/${pre_reg_url}/:id?`,
    name: "PreRegistration",
    meta: {
      auth: false,
      authRequired: false,
      noLayout:true
    },
    component: () => import("./views/preRegistrationForm/form2.vue"),
  },
  {
    path: "/e/:id?",
    name: "PreRegistrationFromEmail",
    meta: {
      auth: false,
      authRequired: false,
      noLayout: true
    },
    // component: () => import("./views/preRegistrationForm/form2.vue"),
    beforeEnter(routeTo, routeFrom, next) {
      next({
        name: "PreRegistration", params: {
          id: routeTo.params.id
        }, query: {
          add_visitor: true
        },
      });
    }
  },
  {
    path: `/${pre_reg_url}/:id?/success`,
    name: "PreRegistration_success",
    meta: {
      auth: false,
      authRequired: false,
      noLayout: true
    },
    component: () => import("@/router/views/preRegistrationForm/qrSuccess.vue"),
  },
  {
    path: "/rfid/:code",
    name: "RFIDEnrollment",
    meta: {
      auth: false,
      authRequired: false,
    },
    component: () => import("./views/users/RFIDEnrollmentFile"),
  },
  // export list
  {
    path: "/reporting/export-list",
    name: "ExportList",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        next();
      },
    },
    beforeEnter: protectedRoutes,
    component: () => import("./views/exportList/ExportListDxGrid"),
  },
  // one time login
  {
    path: "/login-one-time",
    name: "loginOneTime",
    meta: {
      authRequired: false,
    },
    beforeEnter(routeTo) {
      console.log('route');
      let filterdQuery = Object.fromEntries(
        Object.entries(routeTo.query).filter(
          ([key, value]) => value != null || !key
        )
      );
      const searchParams = new URLSearchParams(filterdQuery);
      location.href =
        process.env.VUE_APP_BASE_URL_PASSPORT_REDIRECT +
        "/login-one-time?" +
        searchParams.toString();
    },
  },

  // emergency
  {
    path: "/emergency-list",
    name: "EmergencyList",
    meta: { authRequired: true },
    component: () => import("./views/emergency/EmergencyList"),
    beforeEnter: protectedRoutes,
  },
  {
    path: "/emergency-sessions",
    name: "EmergencySessionsList",
    meta: { authRequired: true },
    component: () => import("./views/emergency/EmergencySessionsList"),
    beforeEnter: protectedRoutes,
  },
  {
    path: "/emergency-sessions/:sessionName/:sessionId",
    name: "EmergencySeesionListData",
    meta: { authRequired: true },
    component: () => import("./views/emergency/EmergencySeesionListData"),
    beforeEnter: protectedRoutes,
  },
  {
    path: "/link-expired",
    name: "linkExpired",
    meta: {
      authRequired: false,
      noLayout: true
    },
    component: () => import("@/router/views/account/link-expired.vue"),
  },
  {
    path: "/attendance-modes",
    name: "attendanceModes",
    meta: { authRequired: true },
    component: () => import("./views/attendanceModes/attendanceModesGrid"),
    beforeEnter: protectedRoutes,
  },
  {
    path: "/add-attendance-mode",
    name: "addAttendanceMode",
    meta: { authRequired: true ,parentRoutePath :'/attendance-modes'},
    component: () => import("./views/attendanceModes/addAttendanceMode"),
    beforeEnter: protectedRoutes,
  },
  {
    path: "/add-reason",
    name: "addReason",
    meta: { authRequired: true },
    component: () => import("./views/attendanceModes/addReason.vue"),
    beforeEnter: protectedRoutes,
  },
];
